import axios from '@plugins/axios'
import Vue from 'vue'
import config from '@src/app.config'
const env = config.env
const appConfig = config[env]

export const state = {
  userSearch: {
    results: []
  },
  loaderMessage: ''
}

export const getters = {
  userSearch: state => state.userSearch,
  loaderMessage: state => state.loaderMessage
}

export const mutations = {
  SET_USER_SEARCH_RESULT(state, result) {
    state.userSearch = result
  },
  SET_LOADER_MSG(state, value){
    state.loaderMessage = value
  }
}

export const actions  = {
  searchUsers({ commit }, payload) {
    const { field, value } = payload
    if (value.trim() === ''){
      commit('SET_USER_SEARCH_RESULT', {results: []})
    } else {
      axios.get(appConfig.server_url + `/profile_management/user/?${field}=${value}&type=like`)
      .then(resp => {
        commit('SET_USER_SEARCH_RESULT', resp.data)
      })
      .catch(err => console.log(err))
    }
  },
  message({ commit }, { title, text, type }) {
    Vue.prototype.$notify({
      group: 'foo',
      title,
      text,
      type,
    })
  },
  loaderMessage({ commit }, text){
    commit('SET_LOADER_MSG', text)
  }
}